export interface IBaseListingModel<T=any> {
  data?: T
  limit?: number;
  skip?: number;
  total?: number;
}

export class BaseListingModel<T = any> implements IBaseListingModel {
  /**
   *
   */
  data?: T
  limit?: number;
  skip?: number;
  total?: number;
  constructor(opt: IBaseListingModel<T>) {
    this.data = opt.data;
    this.limit = opt.skip;
    this.skip = opt.skip;
    this.total = opt.total;
  }
}


// WEBPACK FOOTER //
// ./src/models/base-listing.model.ts